module.exports = __webpack_public_path__ + "static/tat-20-2afce222079fdea7956af14cb977b375.jpg";